import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "row" };
const _hoisted_2 = { class: "col-auto col-lg-7" };
const _hoisted_3 = { class: "col-auto col-lg-12" };
const _hoisted_4 = {
    key: 1,
    class: "error form-group__message"
};
const _hoisted_5 = { key: 0 };
const _hoisted_6 = { key: 0 };
const _hoisted_7 = { key: 1 };
const _hoisted_8 = { key: 2 };
const _hoisted_9 = { key: 3 };
const _hoisted_10 = {
    key: 1,
    class: "gmap-logo",
    src: "/logo.png"
};
const _hoisted_11 = { class: "col-auto col-lg-5 px-0" };
const _hoisted_12 = {
    class: "col-sm-12 control-label",
    for: "addLatitude"
};
const _hoisted_13 = { class: "col-auto col-lg-12" };
const _hoisted_14 = ["disabled", "placeholder"];
const _hoisted_15 = {
    key: 0,
    class: "error form-group__message"
};
const _hoisted_16 = {
    class: "col-sm-12 control-label",
    for: "addLongitude"
};
const _hoisted_17 = { class: "col-auto col-lg-12" };
const _hoisted_18 = ["disabled", "placeholder"];
const _hoisted_19 = {
    key: 0,
    class: "error form-group__message"
};
const _hoisted_20 = {
    class: "col-sm-12 control-label",
    for: "addName"
};
const _hoisted_21 = { class: "col-auto col-lg-12" };
const _hoisted_22 = ["disabled", "placeholder"];
const _hoisted_23 = {
    key: 0,
    class: "error form-group__message"
};
const _hoisted_24 = {
    class: "col-sm-12 control-label",
    for: "addAddress"
};
const _hoisted_25 = { class: "col-sm-12" };
const _hoisted_26 = ["disabled", "placeholder"];
const _hoisted_27 = {
    key: 0,
    class: "error form-group__message"
};
const _hoisted_28 = {
    class: "col-sm-12 control-label",
    for: "addPhone"
};
const _hoisted_29 = { class: "col-sm-12" };
const _hoisted_30 = ["disabled", "placeholder"];
const _hoisted_31 = {
    key: 0,
    class: "error form-group__message"
};
const _hoisted_32 = {
    key: 0,
    class: "mx-3 text-red"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_GMapAutocomplete = _resolveComponent("GMapAutocomplete");
    const _component_GMapInfoWindow = _resolveComponent("GMapInfoWindow");
    const _component_GMapMarker = _resolveComponent("GMapMarker");
    const _component_GMapMap = _resolveComponent("GMapMap");
    return (_openBlock(), _createElementBlock("div", null, [
        _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                    (!$props.viewMode)
                        ? (_openBlock(), _createBlock(_component_GMapAutocomplete, {
                            key: 0,
                            class: "my-2 form-control",
                            placeholder: _ctx.$t('JTADM_HOSPITALS_SEARCH'),
                            onPlace_changed: $setup.markPlace
                        }, null, 8, ["placeholder"]))
                        : _createCommentVNode("", true),
                    ($setup.v$.location.lat.required.$invalid && !$props.viewMode)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.$t('JTADM_VALIDATION_REQUIRED_ADDRESS')), 1))
                        : _createCommentVNode("", true)
                ]),
                ($setup.hospital.location.lon && $setup.hospital.location.lat)
                    ? (_openBlock(), _createBlock(_component_GMapMap, {
                        key: 0,
                        class: "locations-search gmap-modal",
                        center: { lat: parseFloat($setup.hospital.location.lat), lng: parseFloat($setup.hospital.location.lon) },
                        zoom: 15
                    }, {
                        default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.markers, (marker, index) => {
                                return (_openBlock(), _createBlock(_component_GMapMarker, {
                                    key: marker.hospital.id,
                                    animation: 2,
                                    clickable: true,
                                    icon: index === 0 ? '/fasted-marker.png' : '/fasted-marker-grey.png',
                                    position: marker.position,
                                    onClick: ($event) => ($setup.openMarker(marker, index))
                                }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_GMapInfoWindow, {
                                            closeclick: true,
                                            options: $setup.INFO_OPTIONS,
                                            opened: $setup.openedMarkerId === index,
                                            onCloseclick: _cache[0] || (_cache[0] = ($event) => ($setup.openMarker()))
                                        }, {
                                            default: _withCtx(() => [
                                                ($setup.infoContent)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                                        ($setup.infoContent.hospital.name)
                                                            ? (_openBlock(), _createElementBlock("p", _hoisted_6, [
                                                                _createElementVNode("strong", null, "- " + _toDisplayString(`${_ctx.$t('JTADM_NAME')}: `), 1),
                                                                _createElementVNode("span", null, _toDisplayString($setup.infoContent.hospital.name), 1)
                                                            ]))
                                                            : _createCommentVNode("", true),
                                                        ($setup.infoContent.hospital.address)
                                                            ? (_openBlock(), _createElementBlock("p", _hoisted_7, [
                                                                _createElementVNode("strong", null, "- " + _toDisplayString(`${_ctx.$t('JTADM_HOSPITALS_ADDRESS')}: `), 1),
                                                                _createElementVNode("span", null, _toDisplayString($setup.infoContent.hospital.address), 1)
                                                            ]))
                                                            : _createCommentVNode("", true),
                                                        ($setup.infoContent.hospital.phone)
                                                            ? (_openBlock(), _createElementBlock("p", _hoisted_8, [
                                                                _createElementVNode("strong", null, "- " + _toDisplayString(`${_ctx.$t('JTADM_HOSPITALS_PHONE')}: `), 1),
                                                                _createElementVNode("span", null, _toDisplayString($setup.infoContent.hospital.phone), 1)
                                                            ]))
                                                            : _createCommentVNode("", true),
                                                        ($setup.infoContent.hospital.certifications && $setup.infoContent.hospital.certifications.length > 0)
                                                            ? (_openBlock(), _createElementBlock("p", _hoisted_9, [
                                                                _createElementVNode("strong", null, "- " + _toDisplayString(`${_ctx.$t('JTADM_CERTIFICATIONS')}: `), 1)
                                                            ]))
                                                            : _createCommentVNode("", true),
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.infoContent.hospital.certifications, (certification) => {
                                                            return (_openBlock(), _createBlock($setup["CertificationTag"], {
                                                                class: "mx-1",
                                                                key: certification.id,
                                                                classes: "small",
                                                                certification: certification
                                                            }, null, 8, ["certification"]));
                                                        }), 128))
                                                    ]))
                                                    : _createCommentVNode("", true)
                                            ]),
                                            _: 1
                                        }, 8, ["opened"])
                                    ]),
                                    _: 2
                                }, 1032, ["icon", "position", "onClick"]));
                            }), 128))
                        ]),
                        _: 1
                    }, 8, ["center"]))
                    : (_openBlock(), _createElementBlock("img", _hoisted_10))
            ]),
            _createElementVNode("div", _hoisted_11, [
                _createElementVNode("form", null, [
                    _createElementVNode("div", {
                        class: _normalizeClass(["form-group", { 'form-group--error': $setup.v$.location.lat.$error }])
                    }, [
                        _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.$t('JTADM_HOSPITALS_LATITUDE')), 1),
                        _createElementVNode("div", _hoisted_13, [
                            _withDirectives(_createElementVNode("input", {
                                class: "form-control",
                                id: "addLatitude",
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => (($setup.hospital.location.lat) = $event)),
                                type: "text",
                                disabled: $props.viewMode,
                                placeholder: _ctx.$t('JTADM_HOSPITALS_LATITUDE'),
                                onInput: _cache[2] || (_cache[2] =
                                    //@ts-ignore
                                    (...args) => ($setup.v$.location.lat.$touch && $setup.v$.location.lat.$touch(...args)))
                            }, null, 40, _hoisted_14), [
                                [
                                    _vModelText,
                                    $setup.hospital.location.lat,
                                    void 0,
                                    { trim: true }
                                ]
                            ]),
                            ($setup.v$.location.lat.required.$invalid)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(_ctx.$t('JTADM_VALIDATION_REQUIRED_LAT')), 1))
                                : _createCommentVNode("", true)
                        ])
                    ], 2),
                    _createElementVNode("div", {
                        class: _normalizeClass(["form-group", { 'form-group--error': $setup.v$.location.lon.$error }])
                    }, [
                        _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.$t('JTADM_HOSPITALS_LONGITUDE')), 1),
                        _createElementVNode("div", _hoisted_17, [
                            _withDirectives(_createElementVNode("input", {
                                class: "form-control",
                                id: "addLongitude",
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => (($setup.hospital.location.lon) = $event)),
                                type: "text",
                                disabled: $props.viewMode,
                                placeholder: _ctx.$t('JTADM_HOSPITALS_LONGITUDE'),
                                onInput: _cache[4] || (_cache[4] =
                                    //@ts-ignore
                                    (...args) => ($setup.v$.location.lon.$touch && $setup.v$.location.lon.$touch(...args)))
                            }, null, 40, _hoisted_18), [
                                [
                                    _vModelText,
                                    $setup.hospital.location.lon,
                                    void 0,
                                    { trim: true }
                                ]
                            ]),
                            ($setup.v$.location.lon.required.$invalid)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(_ctx.$t('JTADM_VALIDATION_REQUIRED_LON')), 1))
                                : _createCommentVNode("", true)
                        ])
                    ], 2),
                    _createElementVNode("div", {
                        class: _normalizeClass(["form-group", { 'form-group--error': $setup.v$.name.$error }])
                    }, [
                        _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.$t('JTADM_NAME')), 1),
                        _createElementVNode("div", _hoisted_21, [
                            _withDirectives(_createElementVNode("input", {
                                class: "form-control",
                                id: "addName",
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => (($setup.hospital.name) = $event)),
                                type: "text",
                                disabled: $props.viewMode,
                                placeholder: _ctx.$t('JTADM_NAME'),
                                onInput: _cache[6] || (_cache[6] =
                                    //@ts-ignore
                                    (...args) => ($setup.v$.name.$touch && $setup.v$.name.$touch(...args)))
                            }, null, 40, _hoisted_22), [
                                [
                                    _vModelText,
                                    $setup.hospital.name,
                                    void 0,
                                    { trim: true }
                                ]
                            ]),
                            ($setup.v$.name.required.$invalid)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString(_ctx.$t('JTADM_VALIDATION_REQUIRED_NAME')), 1))
                                : _createCommentVNode("", true)
                        ])
                    ], 2),
                    _createElementVNode("div", {
                        class: _normalizeClass(["form-group", { 'form-group--error': $setup.v$.address.$error }])
                    }, [
                        _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.$t('JTADM_HOSPITALS_ADDRESS')), 1),
                        _createElementVNode("div", _hoisted_25, [
                            _withDirectives(_createElementVNode("textarea", {
                                class: "form-control",
                                id: "addAddress",
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => (($setup.hospital.address) = $event)),
                                type: "text",
                                disabled: $props.viewMode,
                                placeholder: _ctx.$t('JTADM_HOSPITALS_HOSPITAL_ADDRESS'),
                                onInput: _cache[8] || (_cache[8] =
                                    //@ts-ignore
                                    (...args) => ($setup.v$.address.$touch && $setup.v$.address.$touch(...args)))
                            }, null, 40, _hoisted_26), [
                                [
                                    _vModelText,
                                    $setup.hospital.address,
                                    void 0,
                                    { trim: true }
                                ]
                            ]),
                            ($setup.v$.address.required.$invalid)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_27, _toDisplayString(_ctx.$t('JTADM_VALIDATION_REQUIRED_ADDRESS')), 1))
                                : _createCommentVNode("", true)
                        ])
                    ], 2),
                    _createElementVNode("div", {
                        class: _normalizeClass(["form-group", { 'form-group--error': $setup.v$.phone.$error }])
                    }, [
                        _createElementVNode("label", _hoisted_28, _toDisplayString(_ctx.$t('JTADM_HOSPITALS_PHONE')), 1),
                        _createElementVNode("div", _hoisted_29, [
                            _withDirectives(_createElementVNode("input", {
                                class: "form-control",
                                id: "addPhone",
                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => (($setup.hospital.phone) = $event)),
                                type: "text",
                                disabled: $props.viewMode,
                                placeholder: _ctx.$t('JTADM_HOSPITALS_PHONE'),
                                onInput: _cache[10] || (_cache[10] =
                                    //@ts-ignore
                                    (...args) => ($setup.v$.phone.$touch && $setup.v$.phone.$touch(...args)))
                            }, null, 40, _hoisted_30), [
                                [
                                    _vModelText,
                                    $setup.hospital.phone,
                                    void 0,
                                    { trim: true }
                                ]
                            ]),
                            ($setup.v$.phone.required.$invalid)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_31, _toDisplayString(_ctx.$t('JTADM_VALIDATION_REQUIRED_PHONE')), 1))
                                : _createCommentVNode("", true)
                        ])
                    ], 2),
                    ($setup.hospital.certifications && $setup.hospital.certifications.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                            _cache[11] || (_cache[11] = _createElementVNode("hr", null, null, -1)),
                            _createElementVNode("h5", null, _toDisplayString(_ctx.$t('JTADM_CERTIFICATIONS_CERT_AND_CAP')), 1),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.sortedCertifications, (certification, index) => {
                                return (_openBlock(), _createBlock($setup["CertificationTag"], {
                                    key: index,
                                    classes: "small",
                                    certification: certification
                                }, null, 8, ["certification"]));
                            }), 128))
                        ]))
                        : _createCommentVNode("", true)
                ])
            ])
        ])
    ]));
}
